import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';
import { CustomerSchema } from '../customers';

export const identitiesApi = apiResourceBuilder({
  name: 'cuss/identities',
  idResolver: ({ key }) => key,
});

export default entityActionCreator({
  schema: CustomerSchema,
  api: identitiesApi,
});



// WEBPACK FOOTER //
// ./src/App/account/actions/identities/index.js